export enum RccapPreselectReversal {    
    Anatomy = 0,
    DonorSurgeonNotAvailable = 1,
    RecipientSurgeonNotAvailable = 2,
    OpRoomAvailability = 3,
    VxmFailure = 4,
    InaccuratePreSelect = 5,
    XmInProgress = 6
}